import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { exhaustMap, map } from "rxjs/operators";
import { AuthService } from '@core/service/auth.service';
import { loggedUser, loggedUserSuccess } from "./auth-user-actions";
import {UserService} from '@feature-module/user/services/user.service';

@Injectable()
export class AuthUserEffects {
  constructor(
    private actions$: Actions,
    private authService: AuthService,
    private userService: UserService
  ) {}

  loggetUser$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(loggedUser),
      exhaustMap(() =>
        this.userService
          .getUserInfo()
          .pipe(map((data) => loggedUserSuccess({ user: data })))
      )
    );
  });
}
